'use client';

import { useEffect, useState } from 'react';

import { useMediaQuery } from '@/ui-tool/media-query';

export function useFixedBarVisibility(getSentinel: () => HTMLElement | null) {
  const isMobile = useMediaQuery('md', 'max');
  const [isBelowViewport, setIsBelowViewport] = useState(false);

  useEffect(() => {
    const sentinel = getSentinel?.();
    if (!sentinel || !isMobile) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsBelowViewport(false);
        } else {
          const viewportBottom = entry.rootBounds?.bottom ?? window.innerHeight;
          setIsBelowViewport(entry.boundingClientRect.top >= viewportBottom);
        }
      },
      { threshold: 0, rootMargin: '0px 0px -100px 0px' }
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [getSentinel, isMobile]);

  return { showFixedBar: isMobile && isBelowViewport };
}
